import { API_BASE_URL, apiGet } from './api-utils';
import { IResult } from '../models/result-models';
import { ISoftwareInfo } from '../models/software';

const softwareInfoUrl = API_BASE_URL + '/v1/SoftwarePage';

export const getSoftwareInfoData = async (): Promise<
    IResult<ISoftwareInfo[]>
> => {
    const result = await apiGet<ISoftwareInfo[]>(softwareInfoUrl);

    return result;
};
